import { RouteRecordRaw } from 'vue-router';

const Layout = () => import('@/layout/index.vue');
const aboutRouter:RouteRecordRaw =  {
    path: '/about',
    component: Layout,
    name: 'about',
    children: [
        {
            path: '',
            name: 'about-index', // 子路由的名称必须以父路由的名称座位起始字符串，为了匹配首页导航选中状态
            component: () => import('@/pages/about/index.vue'),
            meta: {
                title: '关于紫为云'
            }
        },
        {
            path: 'party-detail/:id',
            name: 'about-partyDetail', // 子路由的名称必须以父路由的名称座位起始字符串，为了匹配首页导航选中状态
            component: () => import('@/pages/about/party-detail.vue'),
            meta: {
                title: '党建活动'
            }
        }
    ]
};

export default aboutRouter;
